import {
  useThemeMode,
  brandHex,
  STATUS_HEX,
  STATUS_HEX_DARK,
  CHART_SERIES_DARK,
  CHART_SERIES_LIGHT,
} from "./theme";

export interface ChartColors {
  axis: string;
  grid: string;
  series: (index: number) => string;
  status: Record<string, string>;
}

export function useChartColors(): ChartColors {
  const mode = useThemeMode();
  const dark = mode === "dark";
  // A fixed-order, theme-appropriate categorical ramp. Brand colour leads so
  // the first (most important) series is on-brand; the rest are legible on both
  // surfaces. Stable by index regardless of series count.
  const ramp = dark ? [brandHex(), ...CHART_SERIES_DARK] : [brandHex(), ...CHART_SERIES_LIGHT];
  return {
    axis: dark ? "#94a3b8" : "#64748b",
    grid: dark ? "#334155" : "#e2e8f0",
    series: (i: number) => ramp[i % ramp.length],
    status: dark ? STATUS_HEX_DARK : STATUS_HEX,
  };
}
